var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloud-upload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.018,
    height: 27.514,
    viewBox: "0 0 35.018 27.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5261",
    "data-name": "Path 5261",
    d: "M396.939,456.05a.313.313,0,0,0-.492,0l-4.377,5.538a.312.312,0,0,0,.246.5H395.2v9.474a.314.314,0,0,0,.313.313h2.345a.314.314,0,0,0,.313-.313V462.1h2.9a.312.312,0,0,0,.246-.5Z",
    transform: "translate(-379.184 -444.365)",
    fill: "#bbc6d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5262",
    "data-name": "Path 5262",
    d: "M93.21,168.078a12.5,12.5,0,0,0-23.387,0,7.817,7.817,0,0,0,1.989,15.375H73.38a.314.314,0,0,0,.313-.313v-2.345a.314.314,0,0,0-.313-.313H71.813a4.848,4.848,0,0,1-3.818-7.832,4.9,4.9,0,0,1,2.583-1.708l1.481-.387.543-1.43a9.4,9.4,0,0,1,1.4-2.478,9.6,9.6,0,0,1,2.048-1.95,9.529,9.529,0,0,1,10.943,0,9.6,9.6,0,0,1,2.048,1.95,9.46,9.46,0,0,1,1.4,2.478l.539,1.427,1.477.391a4.868,4.868,0,0,1,3.6,4.694,4.844,4.844,0,0,1-4.842,4.846H89.638a.314.314,0,0,0-.313.313v2.345a.314.314,0,0,0,.313.313h1.567a7.817,7.817,0,0,0,2-15.371Z",
    transform: "translate(-64 -160)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.fe2dc8ef.svg";
export { ForwardRef as ReactComponent };